<template>
  <div class="liu" v-wechat-title="'手持身份证'">
    <!-- 身份信息 -->
    <div class="margin-t-15 color-f-bg">
      <!-- 姓名 -->
      <div class="margin-l-15">
        <div class="flex-s form-item">
          <div style="width: 95px;">姓名</div>
          <input type="tel" class="flex-1" placeholder="请输入姓名" v-model.trim="formData.idCardName" disabled />
        </div>
      </div>
      <!-- 法人身份证 -->
      <div class="margin-l-15">
        <div class="line" />
        <div class="flex-s form-item">
          <div style="width: 95px;">证件号码</div>
          <input type="tel" class="flex-1" placeholder="请输入证件号码" v-model.trim="formData.idCardNum" disabled />
        </div>
      </div>
    </div>
    <!-- 手持身份证照片 -->
    <div class="flex-s color-f-bg page-padding-l-r padding-t-10 padding-b-10 margin-t-10">
      <div style="width: 95px;">
        <div>手持身份</div>
        <div>证正面照</div>
      </div>
      <div class="handFaceStyle" @click="cameraImgClick('shouChi')">
        <img class="img" :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" />
      </div>
    </div>
    <!-- 提示信息 -->
    <div>
      <div class="title-6 say-color page-padding-l-r padding-t-10 padding-b-10">
        <span>避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂</span>
        <span v-if="showTip">，如对比失败，请</span>
        <span v-if="showTip" class="theme-color" @click="resetCameraInfo('shouChi')">重新拍照</span>
        <span v-if="showTip">或</span>
        <span v-if="showTip" class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10">
      <mt-button type="primary" :disabled="!shouChi.webUrl" size="large" @click="onSubmitBtnClick">提交</mt-button>
    </div>
  </div>
</template>

<script>
/* global wx */

import { FaceCompare, GetUserStatus } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'HandIdCard',
  data() {
    return {
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
      },
      // 显示识别失败后的提示
      showTip: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.idCardName = this.$route.query.idcardname;
      this.formData.idCardNum = this.$route.query.idcardnum;
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scweburl).replace('|', '?');
      }
    });
  },
  methods: {
    // 拍照组件点击事件
    cameraImgClick(type) {
      switch (type) {
        case "shouChi":
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'HandIdCard',
        imgType: imgTypeStr,
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
      };
    },
    // 提交数据
    onSubmitBtnClick() {
      this.upLoadData();
    },
    // 提交数据
    upLoadData() {
      CusLoadingOpen();
      FaceCompare({ imageUrl: this.shouChi.webUrl })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.jumpPageStatus();
          } else {
            this.showTip = true;
            CusAlert(res.msg, () => {
              if (res.innerCode === 7776) {
                this.replacePage('auth/manualreview', { idcardname: this.formData.idCardName });
              }
            });
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 跳转页面的状态
    jumpPageStatus() {
      GetUserStatus().then(res => {
        if (res.code === 0) {
          // 1.向小程序发消息，更新状态
          wx.miniProgram.postMessage({ data: { page: "refresh" } });
          // 2.判断是添加储蓄卡还是信用卡，跳转对应的加卡页面
          if (res.data.bankcardStatus === 0) {
            wx.miniProgram.redirectTo({
              url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
            });
          } else if (res.data.bankCreditCardStatus === 0) {
            wx.miniProgram.redirectTo({
              url: `/pages/bankCard/saveCreditcard/saveCreditCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
            });
          } else {
            CusAlert('提交成功', () => {
              wx.miniProgram.navigateBack();
            });
          }
        } else {
          CusAlert('认证成功,状态获取有误,返回首页', () => {
            wx.miniProgram.navigateBack();
          });
        }
      });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.btnStatus = staus;
    },
    // 人工审核
    jumpManualAudit() {
      CusAlert('已为您申请人工审核，预计将在1个工作日内完成。请继续完成后续认证流程，否则将无法通过人工审核', () => {
        this.replacePage('auth/manualreview', { idcardname: this.formData.idCardName });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-t-15 {
  margin-top: 0.75rem;
}

.form-item {
  line-height: 1;
  padding: 0.6rem 0;

  input[type="tel"] {
    width: 100%;
    font-size: $title3;
    outline: 0;
    padding: 0;
    border: 0;

    &:disabled {
      background-color: $highlight-color;
      color: $word-color;
    }

    &::-webkit-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &::-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-ms-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }
  }

  .code {
    width: 6rem;
    text-align: right;
    padding-right: 0.75rem;
    @include dynamic-color;

    &.disabled {
      color: $explain-color !important;
    }
  }
}

.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}
</style>
